module.exports = __webpack_public_path__ + "resources/images/rijbewijs-908a7e45e05229f1198088acc671fede-cache.jpg";